<template>
  <m-pageframe :title="'Demo: Plugin JSON → Bulk Recipient Preview'" :filter_bar="false">
    <v-card class="pa-4">
      <v-text-field v-model="organization_id" label="Organization ID" outlined dense></v-text-field>
      <v-text-field v-model="bulk_message_id" label="Bulk Message ID" outlined dense></v-text-field>

      <v-textarea v-model="json_text" :rows="10" label="Dummy JSON Items (array of objects)" outlined></v-textarea>

      <v-btn color="primary" class="mt-3" @click="startPreview">Start Preview</v-btn>
    </v-card>

    <v-card v-if="process_id" class="pa-4 mt-3">
      <div>Process started: {{ process_id }}</div>
    </v-card>
  </m-pageframe>
</template>

<script>
import ImportProcessPollingMixin from '@/mixins/imports/import-process-polling-mixin.js';

export default {
  name: 'DemoPluginRecipients',
  data() {
    return {
      organization_id: this.$route.params.organization_id || '',
      bulk_message_id: '',
      process_id: null,
      json_text: `[
  { "phone": "15551230001", "first_name": "Ava", "last_name": "Ng", "favorite_color": "blue" },
  { "phone": "15551230002", "first_name": "Diego", "last_name": "Chen", "favorite_color": "red" },
  { "phone": "15551230003", "first_name": "Mia", "last_name": "Singh", "favorite_color": "green" }
]`
    }
  },
  methods: {
    ...ImportProcessPollingMixin.methods,
    onIntermediateComplete(pte) {
      const out = pte.output || {};
      const import_id = out.import_id;
      if (import_id) {
        this.$router.push({
          name: 'bulk-message-recipients-import-upload',
          params: { organization_id: this.organization_id, import_id }
        });
      } else {
        this.$rc.alert('Process did not return import_id', 'error');
      }
    },
    onIntermediateFailed(error) {
      this.$rc.hideSpinner();
      this.$rc.alert('Failed to generate preview', error);
    },
    startPreview() {
      let items;
      try {
        items = JSON.parse(this.json_text);
        if (!Array.isArray(items)) throw new Error('Items must be an array');
      } catch (e) {
        this.$rc.alert('Invalid JSON', e.message);
        return;
      }

      this.$rc.rest({
        endpoint: 'PUT: /api/v1/imports/bulk-message-recipients/plugin/preview/:organization_id/:bulk_message_id',
        spinner: true,
        params: {
          organization_id: this.organization_id,
          bulk_message_id: this.bulk_message_id,
          items
        },
        on_success: (data) => {
          this.process_id = data.process_id;
          
          // Use generic polling method
          this.pollGenericProcess(this.process_id,
              this.onIntermediateComplete.bind(this),
              (error) => this.onIntermediateFailed(error)
          );
          
        },
        on_error: (msg) => this.$rc.alert('Failed to start preview', msg)
      });
    },
  }
}
</script>

